import {
    DEFAULT_MAINTENANCE_RETURN_PATH,
    MAINTENANCE_FORCED_SESSION_KEY,
    MAINTENANCE_PATH,
    MAINTENANCE_RETURN_PATH_SESSION_KEY,
} from './constants';

const normalizeMaintenanceReturnPath = (candidate?: string | null) => {
    if (!candidate || !candidate.startsWith('/') || candidate.startsWith('//')) {
        return DEFAULT_MAINTENANCE_RETURN_PATH;
    }

    if (candidate === MAINTENANCE_PATH || candidate.startsWith(`${MAINTENANCE_PATH}?`)) {
        return DEFAULT_MAINTENANCE_RETURN_PATH;
    }

    return candidate;
};

export const isMaintenanceForced = () => {
    return sessionStorage.getItem(MAINTENANCE_FORCED_SESSION_KEY) === '1';
};

export const getMaintenanceReturnPath = () => {
    return normalizeMaintenanceReturnPath(
        sessionStorage.getItem(MAINTENANCE_RETURN_PATH_SESSION_KEY),
    );
};

export const setMaintenanceReturnPath = (returnPath?: string | null) => {
    sessionStorage.setItem(
        MAINTENANCE_RETURN_PATH_SESSION_KEY,
        normalizeMaintenanceReturnPath(returnPath),
    );
};

export const clearMaintenanceReturnPath = () => {
    sessionStorage.removeItem(MAINTENANCE_RETURN_PATH_SESSION_KEY);
};

export const setMaintenanceRedirectState = (returnPath?: string | null) => {
    sessionStorage.setItem(MAINTENANCE_FORCED_SESSION_KEY, '1');
    setMaintenanceReturnPath(returnPath);
};

export const clearMaintenanceRedirectState = () => {
    sessionStorage.removeItem(MAINTENANCE_FORCED_SESSION_KEY);
    clearMaintenanceReturnPath();
};
